import { render, staticRenderFns } from "./OrderItemCard.vue?vue&type=template&id=29526236&scoped=true"
import script from "./OrderItemCard.vue?vue&type=script&lang=js"
export * from "./OrderItemCard.vue?vue&type=script&lang=js"
import style0 from "./OrderItemCard.vue?vue&type=style&index=0&id=29526236&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_css-loader@0.28.11_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29526236",
  null
  
)

export default component.exports